import { render, staticRenderFns } from "./AddBookingToBasketButton.vue?vue&type=template&id=6bc8eef0&"
import script from "./AddBookingToBasketButton.vue?vue&type=script&lang=js&"
export * from "./AddBookingToBasketButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports